<template>
    <!-- Modal -->
    <div class="modal fade" id="videoBrowserModal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg" style="max-width: 60%;" role="document">
            <div class="modal-content">
                <div class="modal-header d-flex flex-column p-0">
                    <div class="d-flex w-100 align-items-center justify-content-between px-3 pt-3 pb-2">
                        <h5 class="modal-title m-0" id="exampleModalLabel">View available videos</h5>
                        <button type="button" class="close m-0" aria-label="Close" data-dismiss="modal" @click.prevent="closeModel()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="d-flex w-100 align-items-center justify-content-between px-3 pb-2">
                        <div class="d-flex align-items-center">
                            <span class="text-muted mr-2" style="font-size: 13px;">Format:</span>
                            <div class="btn-group btn-group-sm" role="group">
                                <button type="button" class="btn" :class="videoFormat === 'hls' ? 'btn-primary' : 'btn-outline-secondary'" @click="videoFormat = 'hls'">HLS</button>
                                <button type="button" class="btn" :class="videoFormat === 'mp4' ? 'btn-primary' : 'btn-outline-secondary'" @click="videoFormat = 'mp4'">MP4</button>
                            </div>
                        </div>
                        <div class="card-tools">
                            <button type="button" class="btn btn-tool btn-sm" @click.prevent="showUploadModal()">
                                <i class="fas fa-upload"></i> Upload
                            </button>
                            <button type="button" class="btn btn-tool btn-sm" @click.prevent="listVideos()">
                                <i class="fa fa-sync" v-if="!refreshing"></i>
                                <i class="fa fa-sync fa-spin fa-1x" v-if="refreshing"></i>
                                Refresh list
                            </button>
                        </div>
                    </div>
                </div>
                <div class="modal-body">
                    <div class="videos-grid">
                        <div v-for="video, index in videos_list" :key="index" @click="setPlayerVideo(video)" class="video-item" data-category="1">
                            <a data-toggle="lightbox" :data-title="video.title" class="video-content">
                                <picture class="video-thumbnail">
                                    <source :srcset="video.preview+'?'+timestamp()" type="image/webp">
                                    <img :src="video.thumbnail">
                                </picture>
                                <span class="video-title">{{ video.title }}</span>
                                <div class="video-meta">
                                    <div class="meta-item">
                                        <i class="fas fa-clock"></i>
                                        {{ duration(video.length) }}
                                    </div>
                                    <div class="meta-item">
                                        <i class="fas fa-list"></i>
                                        {{ video.size }} MB
                                    </div>
                                </div>
                                <div
                                    v-if="videoFormat === 'mp4' && getMp4Options(video).length > 0"
                                    class="resolution-picker"
                                    @click.stop
                                >
                                    <label class="resolution-label">Resolution</label>
                                    <select
                                        class="custom-select custom-select-sm"
                                        v-model="selectedMp4ResolutionByVideo[getVideoKey(video)]"
                                        @click.stop
                                        @change.stop
                                    >
                                        <option
                                            v-for="variant in getMp4Options(video)"
                                            :key="variant.resolution"
                                            :value="variant.resolution"
                                        >
                                            {{ variant.resolution }}
                                        </option>
                                    </select>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <upload-video @uploaded="listVideos()" @closed="closeUploadModal()" />
    </div>
</template>
<script>
import UploadVideo from '../VideoUpload.vue'

import { RepositoryFactory } from '@/services/repositories/PlayerAPI/RepositoryFactory'
const ContentBrowserRepo = RepositoryFactory.get('content_browser')

export default {
    components: {
        UploadVideo
    },
    props: {
        player_id: {
            type: Number
        }
    },
    data () {
        return {
            videos_list: [],
            refreshing: false,
            videoFormat: 'hls',
            selectedMp4ResolutionByVideo: {}
        }
    },
    mounted() {
        this.listVideos()
    },
    methods: {
        timestamp() {
            return Date.now();
        },
        closeModel: function() {
            this.$emit("closed")
        },
        showUploadModal() {
            $(`#videoUploadModal`).modal()
        },
        closeUploadModal() {
            $('#videoUploadModal').modal('hide')
        },
        listVideos() {
            this.refreshing = true
            ContentBrowserRepo.getVideos().then(result => {
                this.videos_list = (result.data || []).map(video => this.normalizeVideo(video))
                this.refreshing = false
            }).catch(() => {
                this.refreshing = false
            })
        },
        normalizeVideo(video) {
            const variants = Array.isArray(video.mp4_variants)
                ? video.mp4_variants
                    .filter(v => v && v.url && v.resolution)
                    .map(v => ({
                        resolution: v.resolution,
                        url: v.url,
                        height: Number(v.height) || 0
                    }))
                : []

            const sortedVariants = variants.sort((a, b) => b.height - a.height)

            if (!sortedVariants.length && video.mp4_url) {
                sortedVariants.push({
                    resolution: video.mp4_default_resolution || '720p',
                    url: video.mp4_url,
                    height: Number((video.mp4_default_resolution || '').replace('p', '')) || 0
                })
            }

            const normalized = {
                ...video,
                mp4_variants: sortedVariants
            }

            const key = this.getVideoKey(normalized)
            if (!this.selectedMp4ResolutionByVideo[key] && sortedVariants.length > 0) {
                this.$set(this.selectedMp4ResolutionByVideo, key, sortedVariants[0].resolution)
            }

            return normalized
        },
        getVideoKey(video) {
            return video.guid || video.url || video.title
        },
        getMp4Options(video) {
            return Array.isArray(video.mp4_variants) ? video.mp4_variants : []
        },
        getSelectedMp4Url(video) {
            const options = this.getMp4Options(video)
            if (!options.length) {
                return video.mp4_url || video.url
            }

            const key = this.getVideoKey(video)
            const selectedResolution = this.selectedMp4ResolutionByVideo[key]
            const selectedVariant = options.find(v => v.resolution === selectedResolution)

            return (selectedVariant && selectedVariant.url) || options[0].url
        },
        setPlayerVideo(video) {
            var url = this.videoFormat === 'mp4' ? this.getSelectedMp4Url(video) : video.url
            ContentBrowserRepo.changeVideo({url: url, player_id: this.player_id}).then( () => {
                this.$emit('videoSelected', url)
                this.$notify({
                    group: 'ops',
                    type: 'success',
                    title: 'Operation success',
                    text: 'Successfully updated the player video.'
                })
            }).catch(() => {
                this.$notify({
                    group: 'ops',
                    type: 'error',
                    title: 'Operation failed',
                    text: 'Failed to update the player video.'
                })
            })
            this.closeModel()
        },
        reloadvideo() {
            this.$emit("video_updated")
        },
        duration(seconds_) {
            var sec_num = seconds_; // don't forget the second param
            var hours   = Math.floor(sec_num / 3600);
            var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
            var seconds = sec_num - (hours * 3600) - (minutes * 60);

            if (hours   < 10) {hours   = "0"+hours;}
            if (minutes < 10) {minutes = "0"+minutes;}
            if (seconds < 10) {seconds = "0"+seconds;}
            return hours+':'+minutes+':'+seconds;
        }
    }
}
</script>
<style scoped>
@media (min-width: 301px) {
    .modal-lg, .modal-xl {
        max-width: 800px;
    }
}

.videos-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 16px;
    padding: 8px;
    max-height: 60vh;
    overflow-y: auto;
}

.video-item {
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    transition: box-shadow 0.2s ease, transform 0.2s ease;
    background: #fff;
    border: 1px solid #e5e7eb;
}

.video-item:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    transform: translateY(-2px);
}

.video-content {
    display: flex;
    flex-direction: column;
    text-decoration: none;
    color: inherit;
}

.video-thumbnail {
    width: 100%;
    aspect-ratio: 16/9;
    overflow: hidden;
    background: #f3f4f6;
}

.video-thumbnail img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.video-title {
    padding: 8px 10px 4px;
    font-size: 13px;
    font-weight: 500;
    color: #1f2937;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.video-meta {
    display: flex;
    gap: 12px;
    padding: 4px 10px 10px;
    font-size: 12px;
    color: #6b7280;
}

.meta-item {
    display: flex;
    align-items: center;
    gap: 4px;
}

.resolution-picker {
    padding: 0 10px 10px;
}

.resolution-label {
    display: block;
    font-size: 12px;
    color: #4b5563;
    margin-bottom: 4px;
}

.tag {
    color: #008;
    font-family: monospace;
}
.attr-name , .attr-value , .text {
    font-family: monospace;
}
.attr-name {
    color: #606;
} 
.attr-value {
    color: #080;
}
.opacity-trans {
    -webkit-animation: fadeIn 1500ms ;
    -moz-animation: fadeIn 1500ms ;
    animation: fadeIn 1500ms ;
}
@-moz-keyframes fadeIn {
    from {
        opacity:0;
    }
    to {
        opacity:1;
    }
}
@-webkit-keyframes fadeIn {
    from {
        opacity:0;
    }
    to {
        opacity:1;
    }
}
@keyframes fadeIn {
    from {
        opacity:0;
    }
    to {
        opacity:1;
    }
} 

.video-standerd:hover {
    box-shadow: 0 3px 4px rgba(0,0,0,.16),0 3px 6px rgba(0,0,0,.23)!important;    
}


</style>